import { Source } from '@atlassian/mpac-types';
import { appListingLink, encodeAppName } from '@atlassian/mpac-utils';
import { AppTileSource } from './AppTile.types';
export const shouldOpenPartnerLinkInNewTab = source => {
  return source !== AppTileSource.MPAC;
};
export const mpacHosting = hosting => {
  switch (hosting) {
    case 'cloud':
      return 'cloud';
    case 'server':
      return 'server';
    case 'dataCenter':
      return 'datacenter';
    default:
      {
        console.error('Invalid hosting provided : ' + hosting);
        return '';
      }
  }
};
export const resolveHosting = tileData => {
  const {
    deployments,
    documentType
  } = tileData;
  if (!deployments.includes('cloud')) {
    return mpacHosting(documentType);
  }
  return 'cloud';
};
export const getAppListingUrl = (source, hostUrl, tileData) => {
  if (source === Source.PRODUCT) {
    return "".concat(hostUrl, "/discover/app/").concat(tileData.addonKey);
  }
  const url = appListingLink(hostUrl).expand({
    appId: tileData.addonId.toString(),
    slug: encodeAppName(tileData.name),
    hosting: resolveHosting(tileData),
    tab: 'overview'
  });
  return url;
};
export const onTileClick = (tileData, source, hostUrl) => {
  const appListingUrl = getAppListingUrl(source, hostUrl, tileData);
  window.open(appListingUrl);
};